import { CorporateFormValues } from '../../types';

const getCorporateAppicationBody = (values: CorporateFormValues) => {
  const dateOfIncorporation = new Date(values.dateOfIncorporation as string);

  const body: CorporateFormValues = {
    businessAddressSameAsRegisteredAddress:
      values.businessAddressSameAsRegisteredAddress,
    correspondenceAddressSameAsRegisteredAddress:
      values.correspondenceAddressSameAsRegisteredAddress,
  };

  if (values.countryOfIncorporationId) {
    body.countryOfIncorporationId = values.countryOfIncorporationId;
  }

  if (values.companyName) {
    body.companyName = values.companyName;
  }

  if (values.registeredCountryId) {
    body.registeredCountryId = values.registeredCountryId;
  }

  if (values.registeredPostalCode) {
    body.registeredPostalCode = values.registeredPostalCode;
  }

  if (values.registeredAddress2) {
    body.registeredAddress2 = values.registeredAddress2;
  }

  if (values.dateOfIncorporation) {
    body.dateOfIncorporation = values.dateOfIncorporation
      ? `${dateOfIncorporation.getFullYear()}-${(
          dateOfIncorporation.getMonth() + 1
        )
          .toString()
          .padStart(2, '0')}-${dateOfIncorporation
          .getDate()
          .toString()
          .padStart(2, '0')}`
      : '';
  }

  if (values.companyNumber) {
    body.companyNumber = values.companyNumber;
  }

  if (values.websiteLink) {
    body.websiteLink = values.websiteLink;
  }

  if (values.businessDescription) {
    body.businessDescription = values.businessDescription;
  }

  if (values.businessLicense) {
    body.businessLicense = values.businessLicense;
  }

  if (values.registeredAddress1) {
    body.registeredAddress1 = values.registeredAddress1;
  }

  if (values.registeredCity) {
    body.registeredCity = values.registeredCity;
  }

  if (values.monthlyTurnoverRangeId) {
    body.monthlyTurnoverRangeId = values.monthlyTurnoverRangeId;
  }

  if (values.monthlyNumberIncomingTransactionsRangeId) {
    body.monthlyNumberIncomingTransactionsRangeId =
      values.monthlyNumberIncomingTransactionsRangeId;
  }

  if (values.monthlyNumberOutgoingTransactionsRangeId) {
    body.monthlyNumberOutgoingTransactionsRangeId =
      values.monthlyNumberOutgoingTransactionsRangeId;
  }

  if (values.monthlyValueIncomingTransactionsRangeId) {
    body.monthlyValueIncomingTransactionsRangeId =
      values.monthlyValueIncomingTransactionsRangeId;
  }

  if (values.monthlyValueOutgoingTransactionsRangeId) {
    body.monthlyValueOutgoingTransactionsRangeId =
      values.monthlyValueOutgoingTransactionsRangeId;
  }

  if (values.monthlyMaxValueIncomingPaymentRangeId) {
    body.monthlyMaxValueIncomingPaymentRangeId =
      values.monthlyMaxValueIncomingPaymentRangeId;
  }

  if (values.monthlyMaxValueIncomingPaymentRangeId) {
    body.monthlyMaxValueIncomingPaymentRangeId =
      values.monthlyMaxValueIncomingPaymentRangeId;
  }

  if (values.monthlyMaxValueOutgoingPaymentRangeId) {
    body.monthlyMaxValueOutgoingPaymentRangeId =
      values.monthlyMaxValueOutgoingPaymentRangeId;
  }

  if (values.productIds?.length) {
    body.productIds = values.productIds;
  }

  if (values?.requiredCurrenciesCryptoId) {
    body.requiredCurrenciesCryptoId = values?.requiredCurrenciesCryptoId;
  }

  if (values?.amlCtfComplianceProgram?.toString()) {
    body.amlCtfComplianceProgram = Boolean(
      values?.amlCtfComplianceProgram === 'yes',
    );
  }

  if (values?.requiresBusinessLicense?.toString()) {
    body.requiresBusinessLicense = Boolean(
      values?.requiresBusinessLicense === 'yes',
    );
  }

  if (values?.expectedTypeOfClients) {
    body.expectedTypeOfClients = values.expectedTypeOfClients;
  }

  if (values.purposeOfAccount) {
    body.purposeOfAccount = values.purposeOfAccount;
  }

  body.customers =
    values?.customers?.map((item) => ({
      name: item.name,
      monthlyTurnoverRangeId: item.monthlyTurnoverRangeId,
    })) || [];

  body.suppliers =
    values?.suppliers?.map((item) => ({
      name: item.name,
      monthlyTurnoverRangeId: item.monthlyTurnoverRangeId,
    })) || [];

  if (values.deliveryChannelId) {
    body.deliveryChannelId = values.deliveryChannelId;
  }

  if (!values.businessAddressSameAsRegisteredAddress) {
    if (values.businessCountryId) {
      body.businessCountryId = values.businessCountryId;
    }

    if (values.businessCity) {
      body.businessCity = values.businessCity;
    }

    if (values.businessPostalCode) {
      body.businessPostalCode = values.businessPostalCode;
    }

    if (values.businessAddress1) {
      body.businessAddress1 = values.businessAddress1;
    }

    if (values.businessAddress2) {
      body.businessAddress2 = values.businessAddress2;
    }
  }

  if (!values.correspondenceAddressSameAsRegisteredAddress) {
    if (values.correspondenceCountryId) {
      body.correspondenceCountryId = values.correspondenceCountryId;
    }

    if (values.correspondenceCity) {
      body.correspondenceCity = values.correspondenceCity;
    }

    if (values.correspondencePostalCode) {
      body.correspondencePostalCode = values.correspondencePostalCode;
    }

    if (values.correspondenceAddress1) {
      body.correspondenceAddress1 = values.correspondenceAddress1;
    }

    if (values.correspondenceAddress2) {
      body.correspondenceAddress2 = values.correspondenceAddress2;
    }
  }

  if (values.sicCodes?.length) {
    body.sicCodes = values.sicCodes?.filter((item) => item);
  }

  if (values.countriesOfInterestIds?.length) {
    body.countriesOfInterestIds = values.countriesOfInterestIds;
  }

  if (values.vatNumber) {
    body.vatNumber = values.vatNumber;
  }

  return body;
};

export default getCorporateAppicationBody;
